import { createSlice } from "@reduxjs/toolkit";
// import {
//   EditAddTask,
//   getAddTaskFormFieldsJson,
//   PostAddTask,
// } from "./AddTaskActions";
import { getPromptByKey } from "./PromptManagementActions";
import { IPromptManagementResponse } from "../../models/admin/PromptManagement/PromptManagement";
const initialState: IPromptManagementResponse = {
  promptData: {
    promptKey: "",
    promptTemplate: "",
    description: "",
    modificationDate: "",
    modifiedBy: "",
  },
};
const promptManagementSlice = createSlice({
  name: "prompt",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPromptByKey.fulfilled, (state, { payload }) => {
      state.promptData = payload.data;
    });
  },
});

export default promptManagementSlice.reducer;
// export const { setAddTaskFormFieldsJson } = addTaskSlice.actions;
